import { motion, AnimatePresence } from 'motion/react';

import { useVote } from './hooks/useVote';
import { useCarousel } from './hooks/useCarousel';

import AdvtFullSize from './components/AdvtFullSize/AdvtFullSize';
import { QuizContainer } from './components/QuizContainer/QuizContainer';
import { MessagesList } from './components/MessagesList/MessagesList';

function App() {
  const { voteState, currentState, prevState } = useVote();
  const { showedMessages, winnerMessage, speed, mode, keyWinner } =
    useCarousel(currentState);

  return (
    <div className="app-wrapper" style={{ '--speed': `${speed}ms` }}>
      <AnimatePresence mode="popLayout">
        {currentState === 'S1' && (
          <motion.div
            key="advt"
            initial={{ y: !prevState ? 0 : '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '-100%' }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            className="motionBlock"
            style={{ zIndex: '9' }}
          >
            <AdvtFullSize />
          </motion.div>
        )}

        {['S2', 'S3'].includes(currentState) && (
          <motion.div
            key="quiz"
            className="motionBlock"
            initial={{ y: !prevState ? 0 : '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '-100%' }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            style={{ zIndex: '10' }}
          >
            <QuizContainer currentState={currentState} voteState={voteState} />
          </motion.div>
        )}

        {['S4', 'S5', 'S6', 'S7'].includes(currentState) && (
          <motion.div
            key="messageList"
            className="motionBlock"
            initial={{ y: !prevState ? 0 : '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '-100%' }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            style={{ zIndex: '11' }}
          >
            <MessagesList
              mode={mode}
              key="msgList"
              winId={winnerMessage?.['id']}
              messages={showedMessages}
              currentState={currentState}
              speed={speed || 0}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
